/*                                          */
import { EFFECT_TRANSPARENT } from '#client/constants';
import {
	hydrate_next,
	hydrating,
	read_hydration_instruction,
	skip_nodes,
	set_hydrate_node,
	set_hydrating,
	hydrate_node
} from '../hydration.js';
import { block } from '../../reactivity/effects.js';
import { BranchManager } from './branches.js';
import { HYDRATION_START, HYDRATION_START_ELSE } from '../../../../constants.js';

/**
 *
 *
 *
 *
 */
export function if_block(node, fn, elseif = false) {
	/*                                   */
	var marker;
	if (hydrating) {
		marker = hydrate_node;
		hydrate_next();
	}

	var branches = new BranchManager(node);
	var flags = elseif ? EFFECT_TRANSPARENT : 0;

	/**
 *
 *
 */
	function update_branch(key, fn) {
		if (hydrating) {
			var data = read_hydration_instruction(/*                       */ (marker));
			/**
 *
 *
 */
			var hydrated_key;

			if (data === HYDRATION_START) {
				hydrated_key = 0;
			} else if (data === HYDRATION_START_ELSE) {
				hydrated_key = false;
			} else {
				hydrated_key = parseInt(data.substring(1)); /*               */
			}

			if (key !== hydrated_key) {
				/*                                                                       */
				/*                                                          */
				var anchor = skip_nodes();

				set_hydrate_node(anchor);
				branches.anchor = anchor;

				set_hydrating(false);
				branches.ensure(key, fn);
				set_hydrating(true);

				return;
			}
		}

		branches.ensure(key, fn);
	}

	block(() => {
		var has_branch = false;

		fn((fn, key = 0) => {
			has_branch = true;
			update_branch(key, fn);
		});

		if (!has_branch) {
			update_branch(false, null);
		}
	}, flags);
}
